export default __webpack_public_path__ + "static/media/ten.27b42260.png";